import { flex } from '@byecode/ui'
import styled from 'styled-components'

export const Container = styled.div`
    padding: 8px 0;
    font-size: var(--font-size-normal);
`

export const UploadImgContain = styled.div`
    ${flex}
    justify-content: space-around;
    align-items: center;
`

export const UploadImgDesc = styled.div`
    width: 100%;
    padding-left: 8px;
    color: var(--color-gray-500);
    line-height: 24px;
    font-weight: 400;
    font-size: var(--font-size-normal);
    box-sizing: border-box;
`

export const LeftFill = styled.div`
    /* border: 1px solid red; */
`

export const RightFill = styled.div`
    padding-left: 8px;
`
